// import React, { useEffect, useState } from "react";
// import { FaArrowLeft, FaArrowRight, FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";
// import "./Projects.css";

// import designReality1 from "../image/design-reality-01.png";
// import designReality2 from "../image/design-reality-02.png";
// import designReality3 from "../image/design-reality-03.png";

// export default function BeforeAfterGallery() {
//   const navigate = useNavigate();
//   const projects = [
//     { image: designReality1, title: "Design to Reality Project One" },
//     { image: designReality2, title: "Design to Reality Project Two" },
//     { image: designReality3, title: "Design to Reality Project Three" },
//   ];
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [previewImage, setPreviewImage] = useState(null);

//   const getProject = (offset) => {
//     const index = (activeIndex + offset + projects.length) % projects.length;
//     return projects[index];
//   };

//   const goToPrev = () => {
//     setActiveIndex((current) => (current - 1 + projects.length) % projects.length);
//   };

//   const goToNext = () => {
//     setActiveIndex((current) => (current + 1) % projects.length);
//   };

//   const openPreview = (project) => {
//     setPreviewImage(project);
//   };

//   const closePreview = () => {
//     setPreviewImage(null);
//   };

//   useEffect(() => {
//     if (!previewImage) return undefined;

//     const closeOnEscape = (event) => {
//       if (event.key === "Escape") {
//         closePreview();
//       } else if (event.key === "ArrowLeft") {
//         const previewIndex = projects.findIndex((p) => p.title === previewImage?.title);
//         const newIndex = (previewIndex - 1 + projects.length) % projects.length;
//         setPreviewImage(projects[newIndex]);
//       } else if (event.key === "ArrowRight") {
//         const previewIndex = projects.findIndex((p) => p.title === previewImage?.title);
//         const newIndex = (previewIndex + 1) % projects.length;
//         setPreviewImage(projects[newIndex]);
//       }
//     };

//     document.addEventListener("keydown", closeOnEscape);
//     return () => document.removeEventListener("keydown", closeOnEscape);
//   }, [previewImage]);

//   return (
//     <div className="ba-section">
//       <div className="ba-header">
//         <h2 className="ba-heading">See What's Possible Before You Even Start</h2>
//         <p className="ba-subtitle">
//           Witness the journey from concept to completion through our thoughtfully designed and expertly executed projects.
//         </p>
//       </div>

//       <div className="ba2-gallery">
//         <div
//           className="ba2-card ba2-card--side ba2-card--left"
//           role="button"
//           tabIndex={0}
//           onClick={() => openPreview(getProject(-1))}
//           onKeyDown={(event) => event.key === "Enter" && openPreview(getProject(-1))}
//         >
//           <img src={getProject(-1).image} alt={getProject(-1).title} className="ba2-slide-img" />
//         </div>

//         <button className="ba2-nav ba2-nav--prev" type="button" aria-label="Show previous project" onClick={goToPrev}>
//            ←
//         </button>

//         <div
//           className="ba2-card ba2-card--main"
//           role="button"
//           tabIndex={0}
//           onClick={() => openPreview(getProject(0))}
//           onKeyDown={(event) => event.key === "Enter" && openPreview(getProject(0))}
//         >
//           <img src={getProject(0).image} alt={getProject(0).title} className="ba2-slide-img" />
//         </div>

//         <button className="ba2-nav ba2-nav--next" type="button" aria-label="Show next project" onClick={goToNext}>
//           →
//         </button>

//         <div
//           className="ba2-card ba2-card--side ba2-card--right"
//           role="button"
//           tabIndex={0}
//           onClick={() => openPreview(getProject(1))}
//           onKeyDown={(event) => event.key === "Enter" && openPreview(getProject(1))}
//         >
//           <img src={getProject(1).image} alt={getProject(1).title} className="ba2-slide-img" />
//         </div>
//       </div>

//       <div className="ba2-mobile-gallery">
//         {projects.map((item) => (
//           <div
//             className="ba2-card ba2-card--main"
//             key={item.title}
//             role="button"
//             tabIndex={0}
//             onClick={() => openPreview(item)}
//             onKeyDown={(event) => event.key === "Enter" && openPreview(item)}
//           >
//             <img src={item.image} alt={item.title} className="ba2-slide-img" />
//           </div>
//         ))}
//       </div>

//       {/* <div className="ba-btn-container" style={{ display: "flex", justifyContent: "center", marginTop: "30px" }}>
//         <button className="dw-projC-btn" onClick={() => navigate("/projects")}>
//           View More Projects
//         </button>
//       </div> */}

//       {previewImage && (
//         <div className="dw-projC-modal">
//           <div
//             className="dw-projC-modal-overlay"
//             onClick={closePreview}
//           ></div>

//           <motion.div
//             className="dw-projC-modal-box-lightbox"
//             initial={{ opacity: 0, scale: 0.9 }}
//             animate={{ opacity: 1, scale: 1 }}
//             exit={{ opacity: 0, scale: 0.9 }}
//             transition={{ duration: 0.3 }}
//           >
//             {/* Close button */}
//             <button
//               className="dw-lightbox-close"
//               onClick={closePreview}
//               aria-label="Close preview"
//             >
//               ✕
//             </button>

//             {/* Navigation Arrows */}
//             {projects.length > 1 && (
//               <>
//                 <button
//                   className="dw-lightbox-nav dw-lightbox-prev"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     const previewIndex = projects.findIndex((p) => p.title === previewImage?.title);
//                     const newIndex = (previewIndex - 1 + projects.length) % projects.length;
//                     setPreviewImage(projects[newIndex]);
//                   }}
//                   aria-label="Previous project"
//                 >
//                   <FaChevronLeft />
//                 </button>
//                 <button
//                   className="dw-lightbox-nav dw-lightbox-next"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     const previewIndex = projects.findIndex((p) => p.title === previewImage?.title);
//                     const newIndex = (previewIndex + 1) % projects.length;
//                     setPreviewImage(projects[newIndex]);
//                   }}
//                   aria-label="Next project"
//                 >
//                   <FaChevronRight />
//                 </button>
//               </>
//             )}

//             {/* Active Image */}
//             <div className="dw-lightbox-image-wrapper">
//               <img
//                 src={previewImage.image}
//                 alt={previewImage.title}
//                 className="dw-lightbox-image"
//               />
//             </div>

//             {/* Caption Badge */}
//             <div className="dw-lightbox-caption">
//               {previewImage.title}
//             </div>
//           </motion.div>
//         </div>
//       )}
//     </div>
//   );
// }

// import React, { useEffect, useState } from "react";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import { motion } from "framer-motion";
// import "./Projects.css";

// import designReality1 from "../image/design-reality-01.png";
// import designReality2 from "../image/design-reality-02.png";
// import designReality3 from "../image/design-reality-03.png";

// export default function BeforeAfterGallery() {
//   const projects = [
//     { image: designReality1, title: "Design to Reality Project One" },
//     { image: designReality2, title: "Design to Reality Project Two" },
//     { image: designReality3, title: "Design to Reality Project Three" },
//   ];
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [previewImage, setPreviewImage] = useState(null);

//   const getProject = (offset) => {
//     const index = (activeIndex + offset + projects.length) % projects.length;
//     return projects[index];
//   };

//   const goToPrev = () => {
//     setActiveIndex((current) => (current - 1 + projects.length) % projects.length);
//   };

//   const goToNext = () => {
//     setActiveIndex((current) => (current + 1) % projects.length);
//   };

//   const openPreview = (project) => setPreviewImage(project);
//   const closePreview = () => setPreviewImage(null);

//   // ✅ AUTOPLAY — 5 seconds, pauses when lightbox is open
//   useEffect(() => {
//     if (previewImage) return;
//     const timer = setInterval(() => {
//       setActiveIndex((current) => (current + 1) % projects.length);
//     }, 5000);
//     return () => clearInterval(timer);
//   }, [previewImage]);

//   // Keyboard nav for lightbox
//   useEffect(() => {
//     if (!previewImage) return undefined;
//     const closeOnEscape = (event) => {
//       if (event.key === "Escape") {
//         closePreview();
//       } else if (event.key === "ArrowLeft") {
//         const previewIndex = projects.findIndex((p) => p.title === previewImage?.title);
//         setPreviewImage(projects[(previewIndex - 1 + projects.length) % projects.length]);
//       } else if (event.key === "ArrowRight") {
//         const previewIndex = projects.findIndex((p) => p.title === previewImage?.title);
//         setPreviewImage(projects[(previewIndex + 1) % projects.length]);
//       }
//     };
//     document.addEventListener("keydown", closeOnEscape);
//     return () => document.removeEventListener("keydown", closeOnEscape);
//   }, [previewImage]);

//   return (
//     <div className="ba-section">
//       <div className="ba-header">
//         <h2 className="ba-heading">See What's Possible Before You Even Start</h2>
//         <p className="ba-subtitle">
//           Witness the journey from concept to completion through our thoughtfully designed and expertly executed projects.
//         </p>
//       </div>

//       {/* ✅ DESKTOP GALLERY — no arrows */}
//       <div className="ba2-gallery">
//         <div
//           className="ba2-card ba2-card--side ba2-card--left"
//           role="button"
//           tabIndex={0}
//           onClick={() => openPreview(getProject(-1))}
//           onKeyDown={(event) => event.key === "Enter" && openPreview(getProject(-1))}
//         >
//           <img src={getProject(-1).image} alt={getProject(-1).title} className="ba2-slide-img" />
//         </div>

//         <div
//           className="ba2-card ba2-card--main"
//           role="button"
//           tabIndex={0}
//           onClick={() => openPreview(getProject(0))}
//           onKeyDown={(event) => event.key === "Enter" && openPreview(getProject(0))}
//         >
//           <img src={getProject(0).image} alt={getProject(0).title} className="ba2-slide-img" />
//         </div>

//         <div
//           className="ba2-card ba2-card--side ba2-card--right"
//           role="button"
//           tabIndex={0}
//           onClick={() => openPreview(getProject(1))}
//           onKeyDown={(event) => event.key === "Enter" && openPreview(getProject(1))}
//         >
//           <img src={getProject(1).image} alt={getProject(1).title} className="ba2-slide-img" />
//         </div>
//       </div>

//       {/* ✅ DOT INDICATORS */}
//       <div className="ba2-dots">
//         {projects.map((_, i) => (
//           <button
//             key={i}
//             className={`ba2-dot${i === activeIndex ? " ba2-dot--active" : ""}`}
//             onClick={() => setActiveIndex(i)}
//             aria-label={`Go to project ${i + 1}`}
//           />
//         ))}
//       </div>

//       {/* MOBILE GALLERY */}
//       <div className="ba2-mobile-gallery">
//         {projects.map((item) => (
//           <div
//             className="ba2-card ba2-card--main"
//             key={item.title}
//             role="button"
//             tabIndex={0}
//             onClick={() => openPreview(item)}
//             onKeyDown={(event) => event.key === "Enter" && openPreview(item)}
//           >
//             <img src={item.image} alt={item.title} className="ba2-slide-img" />
//           </div>
//         ))}
//       </div>

//       {/* LIGHTBOX */}
//       {previewImage && (
//         <div className="dw-projC-modal">
//           <div className="dw-projC-modal-overlay" onClick={closePreview}></div>
//           <motion.div
//             className="dw-projC-modal-box-lightbox"
//             initial={{ opacity: 0, scale: 0.9 }}
//             animate={{ opacity: 1, scale: 1 }}
//             exit={{ opacity: 0, scale: 0.9 }}
//             transition={{ duration: 0.3 }}
//           >
//             <button className="dw-lightbox-close" onClick={closePreview} aria-label="Close preview">✕</button>
//             {projects.length > 1 && (
//               <>
//                 <button
//                   className="dw-lightbox-nav dw-lightbox-prev"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     const previewIndex = projects.findIndex((p) => p.title === previewImage?.title);
//                     setPreviewImage(projects[(previewIndex - 1 + projects.length) % projects.length]);
//                   }}
//                   aria-label="Previous project"
//                 >
//                   <FaChevronLeft />
//                 </button>
//                 <button
//                   className="dw-lightbox-nav dw-lightbox-next"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     const previewIndex = projects.findIndex((p) => p.title === previewImage?.title);
//                     setPreviewImage(projects[(previewIndex + 1) % projects.length]);
//                   }}
//                   aria-label="Next project"
//                 >
//                   <FaChevronRight />
//                 </button>
//               </>
//             )}
//             <div className="dw-lightbox-image-wrapper">
//               <img src={previewImage.image} alt={previewImage.title} className="dw-lightbox-image" />
//             </div>
//             <div className="dw-lightbox-caption">{previewImage.title}</div>
//           </motion.div>
//         </div>
//       )}
//     </div>
//   );
// }


import React, { useEffect, useState, useRef } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { motion } from "framer-motion";
import "./Projects.css";

import designReality1 from "../image/design-reality-01.png";
import designReality2 from "../image/design-reality-02.png";
import designReality3 from "../image/design-reality-03.png";

export default function BeforeAfterGallery() {
  const projects = [
    { image: designReality1, title: "Design to Reality Project One" },
    { image: designReality2, title: "Design to Reality Project Two" },
    { image: designReality3, title: "Design to Reality Project Three" },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const [previewImage, setPreviewImage] = useState(null);

  // Touch swipe refs
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);
  const SWIPE_THRESHOLD = 50;

  const getProject = (offset) => {
    const index = (activeIndex + offset + projects.length) % projects.length;
    return projects[index];
  };

  const goToPrev = () => {
    setActiveIndex((current) => (current - 1 + projects.length) % projects.length);
  };

  const goToNext = () => {
    setActiveIndex((current) => (current + 1) % projects.length);
  };

  const openPreview = (project) => setPreviewImage(project);
  const closePreview = () => setPreviewImage(null);

  // Touch handlers
  const handleTouchStart = (e) => {
    touchStartX.current = e.changedTouches[0].clientX;
    touchEndX.current = null;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (touchStartX.current === null || touchEndX.current === null) return;
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) >= SWIPE_THRESHOLD) {
      diff > 0 ? goToNext() : goToPrev();
    }
    touchStartX.current = null;
    touchEndX.current = null;
  };

  // Autoplay — 5 seconds, pauses when lightbox is open
  useEffect(() => {
    if (previewImage) return;
    const timer = setInterval(() => {
      setActiveIndex((current) => (current + 1) % projects.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [previewImage]);

  // Keyboard nav for lightbox
  useEffect(() => {
    if (!previewImage) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        closePreview();
      } else if (event.key === "ArrowLeft") {
        const previewIndex = projects.findIndex((p) => p.title === previewImage?.title);
        setPreviewImage(projects[(previewIndex - 1 + projects.length) % projects.length]);
      } else if (event.key === "ArrowRight") {
        const previewIndex = projects.findIndex((p) => p.title === previewImage?.title);
        setPreviewImage(projects[(previewIndex + 1) % projects.length]);
      }
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [previewImage]);

  return (
    <div className="ba-section">
      <div className="ba-header">
        <h2 className="ba-heading">See What's Possible Before You Even Start</h2>
        <p className="ba-subtitle">
          Witness the journey from concept to completion through our thoughtfully designed and expertly executed projects.
        </p>
      </div>

      {/* GALLERY — desktop 3-card, mobile single-card carousel */}
      <div
        className="ba2-gallery"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div
          className="ba2-card ba2-card--side ba2-card--left"
          role="button"
          tabIndex={0}
          onClick={() => openPreview(getProject(-1))}
          onKeyDown={(event) => event.key === "Enter" && openPreview(getProject(-1))}
        >
          <img src={getProject(-1).image} alt={getProject(-1).title} className="ba2-slide-img" />
        </div>

        <div
          className="ba2-card ba2-card--main"
          role="button"
          tabIndex={0}
          onClick={() => openPreview(getProject(0))}
          onKeyDown={(event) => event.key === "Enter" && openPreview(getProject(0))}
        >
          <img src={getProject(0).image} alt={getProject(0).title} className="ba2-slide-img" />
        </div>

        <div
          className="ba2-card ba2-card--side ba2-card--right"
          role="button"
          tabIndex={0}
          onClick={() => openPreview(getProject(1))}
          onKeyDown={(event) => event.key === "Enter" && openPreview(getProject(1))}
        >
          <img src={getProject(1).image} alt={getProject(1).title} className="ba2-slide-img" />
        </div>
      </div>

      {/* DOT INDICATORS */}
      <div className="ba2-dots">
        {projects.map((_, i) => (
          <button
            key={i}
            className={`ba2-dot${i === activeIndex ? " ba2-dot--active" : ""}`}
            onClick={() => setActiveIndex(i)}
            aria-label={`Go to project ${i + 1}`}
          />
        ))}
      </div>

      {/* LIGHTBOX */}
      {previewImage && (
        <div className="dw-projC-modal">
          <div className="dw-projC-modal-overlay" onClick={closePreview}></div>
          <motion.div
            className="dw-projC-modal-box-lightbox"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.3 }}
          >
            <button className="dw-lightbox-close" onClick={closePreview} aria-label="Close preview">✕</button>
            {projects.length > 1 && (
              <>
                <button
                  className="dw-lightbox-nav dw-lightbox-prev"
                  onClick={(e) => {
                    e.stopPropagation();
                    const previewIndex = projects.findIndex((p) => p.title === previewImage?.title);
                    setPreviewImage(projects[(previewIndex - 1 + projects.length) % projects.length]);
                  }}
                  aria-label="Previous project"
                >
                  <FaChevronLeft />
                </button>
                <button
                  className="dw-lightbox-nav dw-lightbox-next"
                  onClick={(e) => {
                    e.stopPropagation();
                    const previewIndex = projects.findIndex((p) => p.title === previewImage?.title);
                    setPreviewImage(projects[(previewIndex + 1) % projects.length]);
                  }}
                  aria-label="Next project"
                >
                  <FaChevronRight />
                </button>
              </>
            )}
            <div className="dw-lightbox-image-wrapper">
              <img src={previewImage.image} alt={previewImage.title} className="dw-lightbox-image" />
            </div>
            <div className="dw-lightbox-caption">{previewImage.title}</div>
          </motion.div>
        </div>
      )}
    </div>
  );
}